/**
 * Sort an array of objects by a sub property (with integer value)
 *
 * @param {*} array | array of objects
 * @param {*} options | object (property, sub_property, order)
 */
export default function(array, options = {}) {
    if (!array && !options.property && !options.sub_property) return;

    // make a copy and return new array
    // keep original in tact
    const sortMe = [...array];

    return sortMe.sort(function(a, b) {
        if (a[options.property] == undefined) {
            a[options.property] = {};
            a[options.property][options.sub_property] = null;
        }
        if (b[options.property] == undefined) {
            b[options.property] = {};
            b[options.property][options.sub_property] = null;
        }

        if (options.order && options.order == "asc") {
            return (
                a[options.property][options.sub_property] -
                b[options.property][options.sub_property]
            );
        } else {
            return (
                b[options.property][options.sub_property] -
                a[options.property][options.sub_property]
            );
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/utilities/sort-by-subprop-int.js